<div class="ts-wrapper" [ngStyle]="style" [ngClass]="styleClass">

  <!-- Trigger input -->
  <div
    class="ts-input"
    [class.ts-disabled]="disabled"
    [ngStyle]="inputStyle"
    (click)="openDialog()">
    <span class="ts-value" *ngIf="value">{{ displayLabel }}</span>
    <span class="ts-placeholder" *ngIf="!value">{{ placeholder }}</span>
    <div class="ts-icons">
      <i
        class="pi pi-times ts-clear"
        *ngIf="showClear && value && !disabled"
        (click)="clear($event)">
      </i>
      <i class="pi pi-search ts-arrow"></i>
    </div>
  </div>

  <!-- Dialog -->
  <p-dialog
    [(visible)]="visible"
    [header]="dialogHeader"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{'width': 'min(1240px, 95vw)'}"
    (onHide)="close()">

    <!-- Search field -->
    <div class="ts-search" [class.mb-2]="secondarySearchPlaceholder" [class.mb-3]="!secondarySearchPlaceholder">
      <span class="p-input-icon-right w-full">
        <i class="pi pi-search"></i>
        <input
          type="text"
          pInputText
          class="w-full p-inputtext-sm"
          [(ngModel)]="searchQuery"
          [placeholder]="searchPlaceholder"
          (input)="onSearchInput()"
          autofocus />
      </span>
    </div>

    <!-- Secondary search field (e.g. CRM) -->
    <div class="ts-search mb-3" *ngIf="secondarySearchPlaceholder">
      <label *ngIf="secondarySearchLabel" class="block text-sm mb-1 text-color-secondary">{{ secondarySearchLabel }}</label>
      <span class="p-input-icon-right w-full">
        <i class="pi pi-search"></i>
        <input
          type="text"
          pInputText
          class="w-full p-inputtext-sm"
          [(ngModel)]="secondarySearchQuery"
          [placeholder]="secondarySearchPlaceholder"
          (input)="onSearchInput()" />
      </span>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="ts-loading">
      <p-progressSpinner
        strokeWidth="4"
        [style]="{'width':'32px','height':'32px'}">
      </p-progressSpinner>
      <span class="text-sm text-color-secondary">Pesquisando...</span>
    </div>

    <!-- Table -->
    <div class="ts-table-container" *ngIf="!loading">
      <p-table
        [value]="suggestions"
        [scrollable]="true"
        scrollHeight="280px"
        [rowHover]="true"
        styleClass="p-datatable-sm">

        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of columns" [style.width]="col.width">
              {{ col.header }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr
            class="ts-row"
            [class.ts-row-selected]="isSelected(item)"
            (click)="selectRow(item)"
            (dblclick)="selectRow(item); confirm()">
            <td *ngFor="let col of columns">{{ col.format ? col.format(item[col.field]) : item[col.field] }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="columns.length" class="text-center text-sm p-3">
              {{ emptyMessage }}
            </td>
          </tr>
        </ng-template>

      </p-table>
    </div>

    <ng-template pTemplate="footer">
      <p-button
        label="Fechar"
        styleClass="p-button-secondary p-button-sm"
        (click)="close()">
      </p-button>
      <p-button
        label="Confirmar"
        styleClass="p-button-sm"
        [disabled]="!pendingRow"
        (click)="confirm()">
      </p-button>
    </ng-template>

  </p-dialog>
</div>
